import { FC } from 'react'

interface Props {
  showSecondColumn?: boolean
}

const LoadingAssetList: FC<Props> = ({ showSecondColumn = false }) => (
  <ul className="flex w-full flex-col gap-2 pt-2">
    {[...new Array(3)].map((_, index) => (
      <li
        key={index}
        className="flex w-full items-center rounded border border-gray-100 bg-white p-4 transition duration-500 ease-out">
        <div className="flex w-full flex-col sm:flex-row sm:items-center">
          <div className="flex flex-1 flex-row gap-3 pr-2 lg:flex-none">
            <div className="size-10 animate-pulse rounded bg-gray-100"></div>
            <div className="flex flex-col gap-1.5 pt-1 lg:w-80 lg:min-w-80 lg:grow-0">
              <div className="h-4 w-32 animate-pulse bg-gray-100" />
              <div className="h-3 w-48 animate-pulse bg-gray-100" />
            </div>
          </div>
          {showSecondColumn && (
            <div className="lg:flex-0 flex flex-1 flex-row gap-1.5 pl-12 pt-2 sm:flex-col sm:pl-0 sm:pt-0">
              <div className="flex flex-row items-center gap-1">
                <div className="size-4 animate-pulse rounded-full bg-gray-100" />
                <div className="h-4 w-16 animate-pulse bg-gray-100" />
              </div>
              <div className="flex flex-row items-center gap-1">
                <div className="size-4 animate-pulse rounded-full bg-gray-100" />
                <div className="h-4 w-32 animate-pulse bg-gray-100" />
              </div>
            </div>
          )}
        </div>
      </li>
    ))}
  </ul>
)

export default LoadingAssetList
